import React, { forwardRef, useMemo, useCallback } from 'react';
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import SemgrepMappingForm from './SemgrepMappingForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { Alert } from 'antd' 

const SemgrepCredentialsForm = forwardRef((props, ref) => {
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => [
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },
        {
          name: "message",
          type: FieldTypes.LABEL,
          value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
        },...(featureFlags.MANAGE_SBOM ? [{
                            name: "ingestSBOM",
                            label: "Ingest Components",
                            type: FieldTypes.SWITCH,
                            help: 'Ingest all components from the projects mapped under this configuration into the Supply Chain module',
                            inline: true,
                          }] : []),
    ], [featureFlags.MANAGE_SBOM])

    const parseExtraFields = useCallback((config) => {
                    return {
                        ...config,
                        ingestSBOM : config.ingestSBOM === "true"
                    };
                }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SemgrepMappingForm}
            initialValue={{ingestSBOM: false}}
            parseExtraFields={parseExtraFields}
        />
    )
});

export default SemgrepCredentialsForm;